import { render, staticRenderFns } from "./AuditionCourse.vue?vue&type=template&id=294ae7c3&scoped=true&"
import script from "./AuditionCourse.vue?vue&type=script&lang=js&"
export * from "./AuditionCourse.vue?vue&type=script&lang=js&"
import style0 from "./AuditionCourse.vue?vue&type=style&index=0&id=294ae7c3&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "294ae7c3",
  null
  
)

export default component.exports